import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';

import { safeChangeLanguage } from './i18n';
import { useAppSelector } from './store';
import { getQueryObj, setQueryObj } from './utils/uri';

export const LanguageChecker: FC<{ children?: ReactNode }> = ({ children }) => {
  const userProfile = useAppSelector((s) => s.userProfile);

  // lang in query
  //
  // PUR-4781: this must stay in an effect. `useAppTranslation` suspends until i18next is ready, so
  // every other `safeChangeLanguage` call site is shielded by the Suspense boundary in App.tsx —
  // but React runs a render body before it discovers a descendant will suspend, so calling from
  // render was the one position nothing could protect. It crashed on `?lang=` reset-password links.
  useEffect(() => {
    const query = getQueryObj();
    if (query.lang) {
      safeChangeLanguage(query.lang);
      delete query.lang;
      setQueryObj(query);
    }
    // Read once on mount. `setQueryObj` strips `lang` via history.replaceState, so re-reading on
    // later renders found nothing to do — but note that only covers the URL the app mounted with:
    // a `?lang=` appended later by in-app navigation is not picked up. Nothing constructs such a
    // link today (the only `lang=` producers are full cross-origin redirects); see docs/TODO.md.
  }, []);

  // lang in profile
  useEffect(() => {
    if (userProfile?.languageCode) {
      safeChangeLanguage(userProfile.languageCode);
    }
  }, [userProfile?.languageCode]);

  return <>{children}</>;
};
